import PubSub from "../../services/PubSub";
import { useEffect } from "react";
import { Modal as BootstrapModal } from "react-bootstrap";
import SettingsView from "./SettingsView";

const SettingsModal = ({
    show,
    onCancel,
    settingsSetId,
    permissions,
    context = {}
}) => {

    useEffect(() => {
        if (show && window.innerWidth < 1024) {
            PubSub.publish(
                "show_info",
                "OTM_SCREEN_TOO_SMALL"
            )
            onCancel();
        }
    }, [show, onCancel]);

    return (
        <BootstrapModal show={show} backdrop="static" centered size="xl" >
            <SettingsView
                show={show}
                onCancel={onCancel}
                settingsSetId={settingsSetId}
                permissions={permissions}
                context={context}
            />
        </BootstrapModal>
    );
};

export default SettingsModal;